import { render, staticRenderFns } from "./VinputNumber.vue?vue&type=template&id=d581d6ba"
import script from "./VinputNumber.vue?vue&type=script&lang=js"
export * from "./VinputNumber.vue?vue&type=script&lang=js"
import style0 from "./VinputNumber.vue?vue&type=style&index=0&id=d581d6ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports